/* ============
 * Municipality Module Mutations
 * ============
 */

import {
  FETCH_MUNICIPALITIES,
} from './../../mutation-types';

export default {
  [FETCH_MUNICIPALITIES](state, { municipalities }) {
    state.all = municipalities;
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/municipality/mutations.js